import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';

import withStyles from '@mui/styles/withStyles';

import { updateFirm } from '../store/slices/firmsSlice';
import { setApiResponseInfo } from '../store/slices/apiResponseInfoSlice';

import { saveWebsiteLinkToDb, deleteWebsiteLinkFromDb } from '../utils/utils';
import { createStdRequest, apiFetch } from '../utils/utils';

import DA from '../store/ReduxAccess';

import WebLinkEditor from './WebLinkEditor';
import OrgPropertyEditor from './OrgPropertyEditor';
import BusinessTypeWidget from './BusinessTypeWidget';

import detailsColumnStyles from '../assets/jss/crm/components/detailsColumnStyles';

class CondensedOrgDetailsColumn extends React.Component {
  state = {};

  saveFirmTypeChangeToDb(firmId, newType) {
    const firm = DA.getFirmById(firmId);
    firm.firmType = newType;
    const uri = '/api/firm';
    const request = createStdRequest(uri, 'post', firm);
    const actionOnGoodResponse = (json) => {
      this.props.updateFirm(firm);
    };
    // call API
    apiFetch(this, request, actionOnGoodResponse);
  }

  render() {
    const { classes, visibleFirmId } = this.props;
    const viewingFirmId = DA.getFirmId();
    const visibleFirm = DA.getFirmById(visibleFirmId);
    const shouldShowPhoneNumberEditor = visibleFirm.firmType !== 'Private Practitioner';
    const webLinks = visibleFirm.webLinks ? visibleFirm.webLinks : [];
    const websiteLink = webLinks.find((wl) => wl.linkType === 'Website');
    const websiteUrl = websiteLink ? websiteLink.url : '';

    return (
      <div className={classes.entityDetails}>
        <div className={cx(classes.entityProfileFrame, classes.entityProfileFrame_organization)}>
          <div className={classes.entityProfileFrame_contentBox}>
            <div className={cx(classes.entityDetails, classes.js_scrollable)}>
              <div className={cx(classes.formFramework_container, classes.formFramework_profileContainer)}>
                <div className={cx(classes.formFramework_layout, classes.formFramework_listLayout)}>
                  <div className={classes.formFramework_listRow}>
                    <div className={cx(classes.formFramework_wrapper, classes.formFramework_editWrapper, 'isRequired')}>
                      <OrgPropertyEditor
                        label="Name"
                        propertyToken="name"
                        visibleFirmId={visibleFirmId}
                        value={visibleFirm.name}
                        required={true}
                      />
                    </div>
                  </div>

                  <div className={classes.formFramework_listRow}>
                    <div className={cx(classes.formFramework_wrapper, classes.formFramework_editWrapper)}>
                      <WebLinkEditor
                        label="Website"
                        linkBoxWidth="186px"
                        initialValue={websiteUrl}
                        clickawayShouldSave={true}
                        onDelete={() =>
                          deleteWebsiteLinkFromDb(this, viewingFirmId, visibleFirmId, this.props.updateFirm)
                        }
                        onNewValue={(newText) =>
                          saveWebsiteLinkToDb(this, viewingFirmId, visibleFirmId, this.props.updateFirm, newText)
                        }
                      />
                    </div>
                  </div>

                  {shouldShowPhoneNumberEditor && (
                    <div className={classes.formFramework_listRow}>
                      <div className={cx(classes.formFramework_wrapper, classes.formFramework_editWrapper)}>
                        <OrgPropertyEditor
                          label="Office Phone"
                          propertyToken="officePhone"
                          visibleFirmId={visibleFirmId}
                          value={visibleFirm.officePhone}
                        />
                      </div>
                    </div>
                  )}

                  <div className={classes.formFramework_listRow}>
                    <div className={cx(classes.formFramework_wrapper, classes.formFramework_editWrapper)}>
                      <OrgPropertyEditor
                        label="Description"
                        propertyToken="description"
                        visibleFirmId={visibleFirmId}
                        value={visibleFirm.description}
                        required={false}
                        multiline={true}
                      />
                    </div>
                  </div>

                  <div className={classes.formFramework_listRow}>
                    <div className={cx(classes.formFramework_wrapper, classes.formFramework_editWrapper)}>
                      <BusinessTypeWidget
                        visibleFirmId={visibleFirmId}
                        onChange={(newFirmType) => this.saveFirmTypeChangeToDb(visibleFirmId, newFirmType)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});
const actionProducers = { updateFirm, setApiResponseInfo };
export default connect(mapStateToProps, actionProducers)(withStyles(detailsColumnStyles)(CondensedOrgDetailsColumn));
